<template>
  <div class="wrapper">
      <video ref="video" id="video" class="video-js vjs-default-skin vjs-big-play-centered" autoplay preload="auto"></video>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import videojs from 'video.js'
import {StatsContentTailler} from '@/utils/constants'
const contentsService = require('@/services/contents.js')

export default {
  name: 'ContentTrailer',
  data () {
    return {
      content: {},
      videoPlayer: null
    }
  },
  mounted: function () {
    if (parseInt(this.$route.params.id) === parseInt(this.$store.getters.content.id) && this.$store.getters.content.trailer) {
      // content store
      this.content = this.$store.getters.content
      this.initPlayer()
      window.Countly.q.push(['track_pageview', StatsContentTailler + ' ' + this.content.id + ': ' + this.content.name])
    } else {
      // content server
      contentsService.getContent(this.$route.params.id).then(response => {
        this.content = response.data
        this.initPlayer()
        window.Countly.q.push(['track_pageview', StatsContentTailler + ' ' + this.content.id + ': ' + this.content.name])
      })
    }

    // control keys
    Bus.$on('key-enter', this.keyEnter)
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-play-pause', this.keyEnter)
    Bus.$on('key-pause', this.keyPause)
    Bus.$on('key-play', this.keyPlay)
    Bus.$on('key-rewind', this.keyRewind)
    Bus.$on('key-forward', this.keyForward)
  },
  methods: {
    initPlayer: function () {
      if (this.content.trailer) {
        this.videoPlayer = videojs(this.$refs.video, {
          // techOrder: ["html5", "flash", "youtube"],
          controls: true,
          controlBar: {
            progressControl: true,
            fullscreenToggle: false,
            volumeControl: false,
            volumeMenuButton: false
          }
        }, () => {
          this.setSrc(this.content.trailer)
        })
      }
    },
    setSrc: function (src) {
      this.videoPlayer.src({type: 'video/mp4', src: src})
    },
    keyEnter: function () { if (this.videoPlayer) { this.videoPlayer.paused() ? this.videoPlayer.play() : this.videoPlayer.pause() } },
    keyPause: function () { if (this.videoPlayer) this.videoPlayer.pause() },
    keyPlay: function () { if (this.videoPlayer) this.videoPlayer.play() },
    keyRewind: function () { if (this.videoPlayer) this.videoPlayer.currentTime(this.videoPlayer.currentTime() - 10) },
    keyForward: function () { if (this.videoPlayer) this.videoPlayer.currentTime(this.videoPlayer.currentTime() + 10) },
    keyBack: function () { this.$router.go(-1) }
  },
  beforeDestroy: function () {
    Bus.$off('key-enter', this.keyEnter)
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-play-pause', this.keyEnter)
    Bus.$off('key-pause', this.keyPause)
    Bus.$off('key-play', this.keyPlay)
    Bus.$off('key-rewind', this.keyRewind)
    Bus.$off('key-forward', this.keyForward)
    if (this.videoPlayer) this.videoPlayer.dispose()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  z-index: 10;
  background-color: #000000

#video
  width: 100vw
  height: 100vh
</style>



// WEBPACK FOOTER //
// src/pages/contents/ContentTrailer.vue